import React from 'react';
import ContactsTable from '../ContactsTable';
import NewCampaignSummary from '../NewCampaignSummary';
import { FormControl, Select, MenuItem, Stack, InputLabel, Paper } from '@mui/material';
import { Help } from '@mui/icons-material';
import RichTooltip from '../../RichTooltip';

const NewData = ({ campaignId, groups, subscriberStatus, setSubscriberStatus, selectedGroup, setSelectedGroup, campaignSummary, onRefreshGroups }) => {
    return (
        <Paper sx={{ p: 2, m: 2 }}>
            <Stack spacing={2}>
                {groups?.length > 0 && (
                    <Stack spacing={1} direction="row" sx={{ alignItems: 'center' }}>
                        <FormControl margin="none" size="small">
                            <InputLabel id="group-select-label">Group</InputLabel>
                            <Select
                                value={selectedGroup}
                                onChange={e => setSelectedGroup(e.target.value)}
                                label="Group"
                                labelId="group-select-label"
                            >
                                <MenuItem value="none">All Groups</MenuItem>;
                                {groups.map(group => <MenuItem key={group.id} value={group.id}>{group.name}</MenuItem>)}
                            </Select>
                        </FormControl>
                        <RichTooltip icon={<Help fontSize="small" />}>
                            Filter Contacts in this Campaign by other Groups they belong to and see how they affect the Campaign Summary data.
                        </RichTooltip>
                    </Stack>
                )}
                <NewCampaignSummary
                    campaign={campaignSummary}
                    subscriberStatus={subscriberStatus}
                    onChangeSubscriberStatus={setSubscriberStatus}
                />
                <ContactsTable
                    selectedGroup={selectedGroup}
                    campaignId={campaignId}
                    status={subscriberStatus}
                    onChangeStatus={setSubscriberStatus}
                    onRefreshGroups={onRefreshGroups}
                />
            </Stack>
        </Paper>
    );
};

export default NewData;